import React from "react";
import { IonButton } from "@ionic/react";

interface props {
	page: any;
	setPage: any;
	onSubmit: any;
	numPages: any;
}

const FormNavigation: React.FC<props> = ({
	page,
	setPage,
	onSubmit,
	numPages,
}) => {
	const _nextPage = () => {
		let toPage = page + 1;
		if (toPage <= numPages - 1) {
			setPage(toPage);
		}
	};

	const _prevPage = () => {
		let toPage = page - 1;
		if (toPage >= 0) {
			setPage(toPage);
		}
	};

	return (
		<div>
			{page !== 0 && <IonButton onClick={_prevPage}>Prev</IonButton>}
			{page !== numPages - 1 && <IonButton onClick={_nextPage}>Next</IonButton>}
			{page === numPages - 1 && (
				<IonButton onClick={onSubmit}>Submit</IonButton>
			)}
		</div>
	);
};

export default FormNavigation;
